module.exports = __webpack_public_path__ + "img/bot.d594ff37.svg";